import { render, staticRenderFns } from "./ProductBelongsTo.vue?vue&type=template&id=492b5b50&"
import script from "./ProductBelongsTo.vue?vue&type=script&lang=js&"
export * from "./ProductBelongsTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports